import { isUsableUrlTitle, type Note } from '../../domain/note'
import { linkPreviewImageUrl } from '../../links/linkMetadata'
import { linkPreviewPresentation } from '../../links/linkPreviewCategory'
import { hideMarkdownPreviewArtifacts } from '../../utils/markdownText'

/** What a note is, in a line or two, for a prompt that asks whether to file it: its name, what it says, its picture. */
export interface NotePreview { title: string; detail: string | null; image: string | null; kind: string | null }

const clip = (text: string, max: number) => text.length > max ? `${text.slice(0, max - 1).trimEnd()}…` : text
const plain = (line: string) => hideMarkdownPreviewArtifacts(line).replace(/https?:\/\/\S+/g, '').replace(/\s+/g, ' ').trim()

export function notePreview(note: Note): NotePreview {
  const link = note.urls[0]
  const linkTitle = link && isUsableUrlTitle(link, link.title) ? plain(link.title ?? '') : ''
  const lines = note.body.split('\n').map(plain).filter(Boolean)
  const title = plain(note.manualTitle ?? '') || linkTitle || plain(note.derivedTitle ?? '') || lines[0] || 'Untitled note'
  const detail = (link?.description ? plain(link.description) : '') || lines.find(line => line !== title) || ''
  return {
    title: clip(title, 90),
    detail: detail && detail !== title ? clip(detail, 140) : null,
    image: link?.imageUrl ? linkPreviewImageUrl(link.imageUrl) : null,
    kind: link ? linkPreviewPresentation(link).label : null,
  }
}
